import { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => { document.title = "SIFT - Terms of Service"; }, []);

  const section = { marginBottom: 28 };
  const h2 = { fontSize: 18, fontWeight: 700, color: "#1a1a1a", marginBottom: 8 };
  const p = { fontSize: 14, lineHeight: 1.7, color: "#555", marginBottom: 8 };

  return (
    <div style={{ fontFamily: "'Montserrat', 'Inter', system-ui, sans-serif", maxWidth: 720, margin: "0 auto", padding: "48px 24px 80px" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');`}</style>

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 32 }}>
        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#2a6b45" }} />
        <span style={{ fontWeight: 800, fontSize: 14, color: "#2a6b45" }}>SIFT</span>
        <span style={{ color: "#e0e0e0", margin: "0 4px" }}>/</span>
        <span style={{ fontSize: 13, color: "#999", fontWeight: 500 }}>Terms of Service</span>
      </div>

      <h1 style={{ fontSize: 28, fontWeight: 800, color: "#1a1a1a", marginBottom: 6 }}>Terms of Service</h1>
      <p style={{ fontSize: 13, color: "#999", marginBottom: 36 }}>Last updated: 27 March 2026</p>

      <div style={section}>
        <h2 style={h2}>1. Acceptance</h2>
        <p style={p}>By installing SIFT on your Shopify store, you agree to these Terms of Service. If you don't agree, please uninstall the app. These terms form a binding agreement between you (the "Merchant") and SIFT.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>2. Service Description</h2>
        <p style={p}>SIFT is a feed intelligence tool that analyses your Shopify product feed, enriches it with consumer search signals from multiple sources, generates AI-optimised product copy, and pushes approved changes back to your store. The service is provided "as is" and may be updated, modified, or discontinued at any time.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>3. Subscriptions & Billing</h2>
        <p style={p}>SIFT offers tiered subscription plans billed through Shopify's billing system. Charges appear on your Shopify invoice. You can cancel at any time through the Shopify admin, and your subscription will remain active until the end of the current billing period. No refunds are provided for partial billing periods.</p>
        <p style={p}>Promotional codes and discounts are subject to their stated terms and may be revoked if misused.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>4. Your Responsibilities</h2>
        <p style={p}>You are responsible for:</p>
        <ul style={{ ...p, paddingLeft: 20 }}>
          <li>Reviewing all AI-generated content before approving it for your store</li>
          <li>Ensuring your product data complies with applicable laws and regulations</li>
          <li>Maintaining the security of your Shopify and Google account credentials</li>
          <li>Complying with Google Merchant Centre policies for product listings</li>
        </ul>
      </div>

      <div style={section}>
        <h2 style={h2}>5. AI-Generated Content</h2>
        <p style={p}>SIFT generates product copy using AI (Anthropic Claude). While we aim for high-quality, accurate output, AI-generated content may contain errors, inaccuracies, or unsuitable language. You must review and approve all changes before they are pushed to your store. SIFT is not responsible for losses arising from AI-generated content that you have approved.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>6. Intellectual Property</h2>
        <p style={p}>You retain ownership of your product data and store content. AI-generated copy created by SIFT for your products becomes your property upon generation. SIFT retains ownership of the application, its algorithms, and underlying technology.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>7. Data & Privacy</h2>
        <p style={p}>Our use of your data is governed by our <a href="/privacy" style={{ color: "#2a6b45", fontWeight: 600 }}>Privacy Policy</a>. By using SIFT, you consent to the data practices described therein.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>8. Limitation of Liability</h2>
        <p style={p}>To the maximum extent permitted by law, SIFT shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or business opportunities, arising from your use of the service. Our total liability shall not exceed the fees paid by you in the 12 months preceding the claim.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>9. Termination</h2>
        <p style={p}>Either party may terminate by uninstalling the app. We may suspend or terminate your access if you breach these terms or misuse the service. Upon termination, we will delete your data in accordance with our Privacy Policy.</p>
      </div>

      <div style={section}>
        <h2 style={h2}>10. Governing Law</h2>
        <p style={p}>These terms are governed by the laws of England and Wales. Disputes will be resolved in the courts of London, England.</p>
      </div>

      <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: 20, marginTop: 40 }}>
        <p style={{ fontSize: 12, color: "#999" }}>Contact: legal@sift.ai</p>
      </div>
    </div>
  );
}
